import pushRecord from './pushRecord'
import pushSettings from './pushSettings'
import pushHistory from './pushHistory'

export default {
  pushRecord,
  pushHistory,
  pushSettings
}



// WEBPACK FOOTER //
// ./src/api/apis/self/push/index.js